<template>
  <v-container>
    <v-dialog v-model="dialog" max-width="1000px" persistent>
      <v-card>
        <v-card-title>
          <span class="headline">{{ tituloModal }}</span>
          <v-spacer></v-spacer>
          <v-btn color="grey lighten-1" text @click="cerrarModal">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <!-- contenido -->
        <ValidationObserver ref="form_datos">
          <v-card class="mx-auto" :loading="loading">
            <v-card-text class="text--primary px-8">
              <v-row>
                <v-col cols="12" sm="6" md="6">
                  <ValidationProvider name="Clase" rules="required">
                    <v-autocomplete
                      v-model="objDatos.clase"
                      :items="clases"
                      item-text="clase"
                      item-value="clase"
                      label="Clase"
                      slot-scope="{ errors, valid }"
                      :error-messages="errors"
                      :success="valid"
                    ></v-autocomplete>
                  </ValidationProvider>
                </v-col>

                <v-col cols="12" sm="6" md="6">
                  <ValidationProvider name="Carroceria" rules="required">
                    <v-autocomplete
                      v-model="objDatos.carroceria"
                      :items="carrocerias"
                      item-text="carroceria"
                      item-value="carroceria"
                      label="Carrocería"
                      slot-scope="{ errors, valid }"
                      :error-messages="errors"
                      :success="valid"
                    ></v-autocomplete>
                  </ValidationProvider>
                </v-col>

                <v-col cols="12" sm="6" md="6">
                  <v-text-field
                    v-model="objDatos.informacionadicional"
                    label="Información Adicional"
                    required
                  ></v-text-field>
                </v-col>

                <v-col cols="12" sm="6" md="6">
                  <ValidationProvider name="Marca" rules="required">
                    <v-autocomplete
                      v-model="marca"
                      :items="marcas"
                      item-text="marca"
                      item-value="marca"
                      label="Marca"
                      slot-scope="{ errors, valid }"
                      :error-messages="errors"
                      :success="valid"
                    ></v-autocomplete>
                  </ValidationProvider>
                </v-col>

                <v-col cols="12" sm="6" md="6">
                  <ValidationProvider name="Linea" rules="required">
                    <v-autocomplete
                      v-model="objDatos.linea"
                      :items="lineas"
                      item-text="linea"
                      item-value="linea"
                      label="Linea"
                      slot-scope="{ errors, valid }"
                      :error-messages="errors"
                      :success="valid"
                    ></v-autocomplete>
                  </ValidationProvider>
                </v-col>

                <v-col cols="12" sm="6" md="6">
                  <ValidationProvider name="Año Modelo" rules="required">
                    <v-text-field
                      v-model="objDatos.modelo"
                      type="text"
                      label="Año Modelo"
                      slot-scope="{ errors, valid }"
                      :error-messages="errors"
                      :success="valid"
                      required
                    ></v-text-field>
                  </ValidationProvider>
                </v-col>

                <v-col cols="12" sm="6" md="6">
                  <ValidationProvider name="Placa" rules="required|min:5">
                    <v-text-field
                      v-model="objDatos.placa"
                      type="text"
                      label="Placa"
                      slot-scope="{ errors, valid }"
                      :error-messages="errors"
                      :success="valid"
                      required
                    ></v-text-field>
                  </ValidationProvider>
                </v-col>

                <v-col cols="12" sm="6" md="6">
                  <ValidationProvider name="Poliza" rules="">
                    <v-text-field
                      v-model="objDatos.poliza"
                      type="text"
                      label="Póliza"
                      required
                      slot-scope="{ errors, valid }"
                      :error-messages="errors"
                      :success="valid"
                    ></v-text-field>
                  </ValidationProvider>
                </v-col>

                <v-col cols="12" sm="6" md="6">
                  <ValidationProvider name="Servicio" rules="required">
                    <v-autocomplete
                      v-model="objDatos.servicio"
                      :items="servicio"
                      item-text="name"
                      item-value="value"
                      label="Servicio"
                      slot-scope="{ errors, valid }"
                      :error-messages="errors"
                      :success="valid"
                    ></v-autocomplete>
                  </ValidationProvider>
                </v-col>

                <v-col cols="12" sm="6" md="6">
                  <ValidationProvider name="Cliente" rules="required">
                    <v-autocomplete
                      v-model="objDatos.uidcliente"
                      :search-input.sync="searchUsuario"
                      :items="clientes"
                      item-text="nombresCompleto"
                      item-value="id"
                      label="Clientes"
                      slot-scope="{ errors, valid }"
                      :error-messages="errors"
                      :success="valid"
                    ></v-autocomplete>
                  </ValidationProvider>
                </v-col>

                <v-col v-if="this.id" cols="12" sm="6" md="6">
                  <v-autocomplete
                    v-model="objDatos.estado"
                    :items="state"
                    item-text="name"
                    item-value="val"
                    label="Estado"
                  ></v-autocomplete>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </ValidationObserver>
        <!-- fin contenido -->
        <v-card-actions class="pb-8 pl-8">
          <v-btn @click="save" color="primary" dark :loading="loading">
            Guardar
          </v-btn>
          <v-btn color="warning" dark @click="cerrarModal"> Cancelar </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import { db } from "../../firebase";
export default {
  name: "ModalVehiculos",
  data: () => ({
    objDatos: {},
    dialog: true,
    loading: true,
    servicio: [
      { name: "PÚBLICO", value: "PÚBLICO" },
      { name: "PARTICULAR", value: "PARTICULAR" },
      { name: "DIPLOMÁTICO", value: "DIPLOMÁTICO" },
      { name: "OFICIAL", value: "OFICIAL" },
      { name: "ESPECIAL RNMA", value: "ESPECIAL RNMA" },
    ],
    state: [
      { name: "Activo", val: true },
      { name: "Inactivo", val: false },
    ],
    clases: [
      {
        clase: "AUTOMÓVIL",
        carrocerias: [
          { carroceria: "SEDAN" },
          { carroceria: "COUPE" },
          { carroceria: "CONVERTIBLE" },
          { carroceria: "STATION WAGON" },
          { carroceria: "HATCH BACK" },
          { carroceria: "COUPE CONVERTIBLE" },
          { carroceria: "BUGGY" },
          { carroceria: "LIMOSINA" },
          { carroceria: "BREAK" },
        ],
      },
      {
        clase: "BUS",
        carrocerias: [
          { carroceria: "CERRADA" },
          { carroceria: "ABIERTO (ESCALERA)" },
          { carroceria: "ARTICULADO" },
          { carroceria: "BIARTICULADO" },
          { carroceria: "UNIDAD MOVIL" },
        ],
      },
      {
        clase: "BUSETA",
        carrocerias: [
          { carroceria: "CERRADA" },
          { carroceria: "ABIERTO (ESCALERA)" },
          { carroceria: "AMBULANCIA" },
          { carroceria: "UNIDAD MOVIL" },
        ],
      },
      {
        clase: "CAMION",
        carrocerias: [
          { carroceria: "ESTACAS" },
          { carroceria: "FURGON" },
          { carroceria: "TANQUE" },
          { carroceria: "TOLVA" },
          { carroceria: "RECOLECTOR COMPACTADOR" },
          { carroceria: "ESTIBAS" },
          { carroceria: "HORMIGONERO" },
          { carroceria: "GRUA" },
          { carroceria: "NIÑERA" },
          { carroceria: "DOBLE CABINA" },
          { carroceria: "BOMBERO" },
          { carroceria: "BOMBA" },
          { carroceria: "LIMPIA ALCANTARILLAS" },
          { carroceria: "BOMBA DE CONCRETO" },
          { carroceria: "PANEL" },
          { carroceria: "PLATAFORMA" },
          { carroceria: "RECOLECTOR" },
          { carroceria: "TALADRO" },
          { carroceria: "CASA RODANTE" },
          { carroceria: "AMBULANCIA" },
          { carroceria: "PLATAFORMA CON EQUIPO ESPECIAL" },
          { carroceria: "GENERADOR DE NITROGENO" },
          { carroceria: "MEZCLADOR" },
          { carroceria: "PLANCHON" },
          { carroceria: "REPARTO Ó PALET" },
          { carroceria: "DOBLE CABINA ESTACAS" },
          { carroceria: "DOBLE CABINA FURGON" },
          { carroceria: "PORTA CONTENEDOR" },
          { carroceria: "CAÑERO" },
          { carroceria: "BARREDORA" },
          { carroceria: "PLANCHON - PLATAFORMA" },
          { carroceria: "DOBLE CABINA PANEL" },
          { carroceria: "PICO (PICK UP)" },
          { carroceria: "FURGON CON EQUIPO ESPECIAL" },
          { carroceria: "BOMBA DE CEMENTACION" },
          { carroceria: "BOMBA DE NITROGENO" },
          { carroceria: "BLINDADO PARA TRANSPORTE DE VALORES" },
          { carroceria: "GRUA AEREA" },
          { carroceria: "GRUA DE SOSTENIMIENTO DE REDES" },
          { carroceria: "EQUIPO IRRIGADOR DE AGUA" },
          { carroceria: "EQUIPO IRRIGADOR DE ASFALTO" },
          { carroceria: "EQUIPO DE LAVADO Y SUCCION" },
          { carroceria: "EQUIPO DE SANEAMIENTO AMBIENTAL" },
          { carroceria: "CARROTALLER" },
          { carroceria: "EQUIPO DE RIEGO" },
          { carroceria: "EQUIPO DE MINERIA" },
          { carroceria: "TANQUETA" },
          { carroceria: "CABINA EXTENDIDA" },
          { carroceria: "DOBLE CABINA" },
          { carroceria: "LABORATORIO" },
          { carroceria: "EQUIPO ESPECIAL DEL SECTOR PETROLERO" },
          { carroceria: "UNIDAD DE CEMENTACION" },
          { carroceria: "PLATAFORMA GRUA CON KING PING" },
          { carroceria: "PLANCHÓN CON GRÚA" },
          { carroceria: "FURGÓN UNIDAD MÓVIL" },
          { carroceria: "PLATAFORMA BARANDAS DESMONTABLES" },
          { carroceria: "COMPACTADOR DE BASURAS" },
          { carroceria: "PORTAFURGON" },
          { carroceria: "GRUA PLANCHON" },
          { carroceria: "PLATAFORMA BARANDAS DESARMABLES" },
          { carroceria: "PLATAFORMA CON ESTACAS METALICAS" },
          { carroceria: "PORTA EQUIPO ESPECIAL" },
          { carroceria: "PORTA PLATAFORMA" },
          { carroceria: "PORTA TANQUE" },
          { carroceria: "EQUIPO DE LAVADO" },
          { carroceria: "EQUIPO DE PERFORACION" },
          { carroceria: "SILO GRANELERO" },
          { carroceria: "FURGON DE CORTINAS PARA PALETIZADO" },
          { carroceria: "CESTA AEREA AISLADA CON GABINETES" },
          { carroceria: "TANQUE AL VACIO" },
          { carroceria: "BOTELLERO" },
        ],
      },
      {
        clase: "CAMIONETA",
        carrocerias: [
          { carroceria: "PICO (PICK UP)" },
          { carroceria: "CARPADO" },
          { carroceria: "VAN" },
          { carroceria: "AMBULANCIA" },
          { carroceria: "TANQUE" },
          { carroceria: "TALLER" },
          { carroceria: "STATION WAGON" },
          { carroceria: "ESTACAS" },
          { carroceria: "FURGON" },
          { carroceria: "GRUA" },
          { carroceria: "DOBLE CABINA" },
          { carroceria: "PANEL" },
          { carroceria: "DOBLE CABINA ESTACAS" },
          { carroceria: "ESTIBAS" },
          { carroceria: "WAGON" },
          { carroceria: "PLATAFORMA" },
          { carroceria: "UNIDAD MOVIL" },
          { carroceria: "REPARTO ó PALET" },
          { carroceria: "DOBLE CABINA CERRADA" },
          { carroceria: "PLATAFORMA CON EQUIPO ESPECIAL" },
          { carroceria: "PLANCHON - PLATAFORMA" },
          { carroceria: "DOBLE CABINA FURGON" },
          { carroceria: "PICÓ CERRADA" },
          { carroceria: "DOBLE CABINA CON PLATAFORMA" },
          { carroceria: "DOBLE CABINA TRACCION SENCILLA" },
          { carroceria: "BOMBERO" },
          { carroceria: "CABINA EXTENDIDA" },
          { carroceria: "RECOLECTOR COMPACTADOR" },
          { carroceria: "HATCH BACK" },
          { carroceria: "PORTA CONTENEDOR" },
          { carroceria: "PICK UP (PICÓ) SENCILLA" },
          { carroceria: "PORTAFURGON" },
          { carroceria: "GRUA AEREA" },
          { carroceria: "GRUA DE SOSTENIMIENTO DE REDES" },
          { carroceria: "DOBLE CABINA CON PLATON" },
        ],
      },
      {
        clase: "CAMPERO",
        carrocerias: [
          { carroceria: "CABINADO" },
          { carroceria: "CARPADO" },
          { carroceria: "WAGON" },
          { carroceria: "ESTACAS" },
          { carroceria: "CAPOTA DUAL " },
          { carroceria: "FURGON" },
          { carroceria: "CONVERTIBLE" },
        ],
      },
      {
        clase: "MICROBUS",
        carrocerias: [
          { carroceria: "CERRADA" },
          { carroceria: "VAN" },
          { carroceria: "ABIERTO (ESCALERA)" },
        ],
      },
      {
        clase: "TRACTOCAMION",
        carrocerias: [
          { carroceria: "SRS" },
          { carroceria: "GRUA" },
          { carroceria: "SIN CARROCERIA" },
        ],
      },
      { clase: "MOTOCICLETA", carrocerias: [{ carroceria: "SIN CARROCERIA" }] },
      {
        clase: "MOTOCARRO",
        carrocerias: [
          { carroceria: "ESTACAS" },
          { carroceria: "FURGON" },
          { carroceria: "ESTIBAS" },
          { carroceria: "REPARTO" },
          { carroceria: "PANEL" },
          { carroceria: "PICO" },
          { carroceria: "CABINADO" },
          { carroceria: "CARPADO" },
          { carroceria: "PLATON" },
          { carroceria: "SEMICERRADA" },
        ],
      },
      {
        clase: "MOTOTRICICLO",
        carrocerias: [{ carroceria: "SIN CARROCERIA" }],
      },
      { clase: "CUATRIMOTO", carrocerias: [{ carroceria: "SIN CARROCERIA" }] },
      {
        clase: "REMOLQUE",
        carrocerias: [
          { carroceria: "CAMABAJA" },
          { carroceria: "FURGON" },
          { carroceria: "NIÑERA" },
          { carroceria: "REPARTO Ó PALET" },
          { carroceria: "ESTIBAS" },
          { carroceria: "TANQUE" },
          { carroceria: "GRANELERAS" },
          { carroceria: "VOLCO" },
          { carroceria: "EQUIPO PETROLERO" },
          { carroceria: "CAÑERO" },
          { carroceria: "GRUA ELEVADORA" },
          { carroceria: "TOLVA" },
          { carroceria: "HORMIGONERO" },
          { carroceria: "GRUA" },
          { carroceria: "BOMBA" },
          { carroceria: "RECOLECTOR" },
          { carroceria: "CASA RODANTE" },
          { carroceria: "EQUIPO DE CEMENTACION Ó BOMBA DE HORMIGON" },
          { carroceria: "MEZCLADOR" },
          { carroceria: "FURGON FRIGORIFICO" },
          { carroceria: "FURGON CORTINERO" },
          { carroceria: "CISTERNA SILO CILINDRICO" },
          { carroceria: "SRS" },
          { carroceria: "PLATON" },
          { carroceria: "CABINADO" },
          { carroceria: "CARPADO" },
          { carroceria: "DOBLE CABINA" },
          { carroceria: "BOMBERO" },
          { carroceria: "PANEL" },
          { carroceria: "ABIERTO (ESCALERA)" },
          { carroceria: "VAN" },
          { carroceria: "UNIDAD MOVIL" },
          { carroceria: "PLATAFORMA CON EQUIPO ESPECIAL" },
          { carroceria: "SPOOLER" },
          { carroceria: "PLAT-ESTA" },
          { carroceria: "PLATAFORMA CON ESTACAS DESMONTABLES" },
          { carroceria: "VOLCO - PLATON" },
          { carroceria: "TOLVA PIPA CEMENTERA" },
          { carroceria: "TANQUE DE LODOS" },
          { carroceria: "PLATAFORMA BARANDAS DESARMABLES" },
          { carroceria: "PLATAFORMA BRAZO AUTOPORTANTE" },
          { carroceria: "VOLQUETE" },
          { carroceria: "UNIDAD DE CEMENTACION" },
          { carroceria: "FRAC TANK" },
          { carroceria: "PLATAFORMA MODULAR CARBONERA" },
          { carroceria: "CISTERNA" },
          { carroceria: "CAMABAJA CON EQUIPO ESPECIAL" },
          { carroceria: "BOTELLERO" },
          { carroceria: "CAMPAMENTO" },
          { carroceria: "TANQUE (GRANELERO)" },
          { carroceria: "TANQUE FRAC TANK" },
          { carroceria: "BOMBA ACIDOS" },
          { carroceria: "FURGON REFRIGERADO" },
          { carroceria: "FURGON (TRITURADOR DE PAPEL)" },
          { carroceria: "PLATAFORMA" },
          { carroceria: "PLANCHON" },
          { carroceria: "ESTACAS" },
          { carroceria: "PORTA CONTENEDOR" },
          { carroceria: "MESA ROTATORIA" },
          { carroceria: "UNIDAD DE ALMACENAMIENTO" },
          { carroceria: "PORTAMODULOS PARA GAS" },
          { carroceria: "MODULAR" },
          { carroceria: "EQUIPO NITROGENO" },
          { carroceria: "GASODUCTO MOVIL" },
          { carroceria: "MULTIPROPOSITO" },
          { carroceria: "EQUIPO CARBONERO" },
          { carroceria: "NIÑERA MULTIPROPOSITO" },
          { carroceria: "TANQUE ESFERICO" },
          { carroceria: "TANQUE CILINDRICO" },
          { carroceria: "CARBONERA" },
          { carroceria: "PLATAFORMA DE TIRO" },
          { carroceria: "FURGON-SIDER" },
        ],
      },
      {
        clase: "SEMIREMOLQUE",
        carrocerias: [
          { carroceria: "CAMABAJA" },
          { carroceria: "FURGON" },
          { carroceria: "NIÑERA" },
          { carroceria: "ESTIBAS" },
          { carroceria: "TANQUE" },
          { carroceria: "VOLCO" },
          { carroceria: "PORTA CONTENEDOR" },
          { carroceria: "EQUIPO PETROLERO" },
          { carroceria: "CAÑERO" },
          { carroceria: "TOLVA" },
          { carroceria: "HORMIGONERO" },
          { carroceria: "BOMBA" },
          { carroceria: "DOLLY" },
          { carroceria: "CISTERNA SILO CILINDRICO" },
          { carroceria: "VAN" },
          { carroceria: "PLATAFORMA CON EQUIPO ESPECIAL" },
          { carroceria: "PLAT-ESTA" },
          { carroceria: "PLATAFORMA CON ESTACAS DESMONTABLES" },
          { carroceria: "PLATAFORMA CON ESTACAS METALICAS" },
          { carroceria: "VOLCO - PLATON" },
          { carroceria: "TOLVA PIPA CEMENTERA" },
          { carroceria: "TANQUE DE LODOS" },
          { carroceria: "PLATAFORMA BARANDAS DESARMABLES" },
          { carroceria: "PLATAFORMA BRAZO AUTOPORTANTE" },
          { carroceria: "VOLQUETE" },
          { carroceria: "UNIDAD DE CEMENTACION" },
          { carroceria: "FRAC TANK" },
          { carroceria: "PLATAFORMA MODULAR CARBONERA" },
          { carroceria: "CISTERNA" },
          { carroceria: "CAMABAJA CON EQUIPO ESPECIAL" },
          { carroceria: "BOTELLERO" },
          { carroceria: "CAMPAMENTO" },
          { carroceria: "TANQUE (GRANELERO)" },
          { carroceria: "TANQUE FRAC TANK" },
          { carroceria: "BOMBA ACIDOS" },
          { carroceria: "FURGON REFRIGERADO" },
          { carroceria: "FRACTURADOR" },
          { carroceria: "PLATAFORMA MODULAR" },
          { carroceria: "FURGON CAMABAJA" },
          { carroceria: "EQUIPO DE PAVIMENTACION" },
          { carroceria: "TRANSPORTADOR DE TUBOS" },
          { carroceria: "BOMBA DE CEMENTACION" },
          { carroceria: "CAMA CUNA" },
          { carroceria: "CAMABAJA BAGACERO" },
          { carroceria: "CAMA ALTA" },
          { carroceria: "PLATAFORMA" },
          { carroceria: "PLANCHON" },
          { carroceria: "ESTACAS" },
          { carroceria: "PLATON" },
          { carroceria: "PORTAMODULOS PARA GAS" },
          { carroceria: "MULTIPROPOSITO" },
          { carroceria: "EQUIPO CARBONERO" },
          { carroceria: "NIÑERA MULTIPROPOSITO" },
          { carroceria: "TANQUE ESFERICO" },
          { carroceria: "TANQUE CILINDRICO" },
          { carroceria: "CARBONERA" },
          { carroceria: "PLATAFORMA DE TIRO" },
          { carroceria: "UNIDAD MOVIL" },
          { carroceria: "MULTIPLE" },
          { carroceria: "BAGACERO" },
          { carroceria: "EYECTOR" },
          { carroceria: "TRANSPORTADOR DE CEMENTO" },
          { carroceria: "ESTRUCTURA AJUSTABLE" },
        ],
      },
      {
        clase: "VOLQUETA",
        carrocerias: [
          { carroceria: "PLATON" },
          { carroceria: "VOLCO DESMONTABLE" },
        ],
      },
      { clase: "SIN CLASE", carrocerias: [{ carroceria: "SIN CARROCERIA" }] },
      {
        clase: "MAQ. CONSTRUCCION O MINERA",
        carrocerias: [{ carroceria: "SIN CARROCERIA" }],
      },
      { clase: "CICLOMOTOR", carrocerias: [{ carroceria: "SIN CARROCERIA" }] },
      { clase: "TRICIMOTO", carrocerias: [{ carroceria: "SIN CARROCERIA" }] },
      { clase: "CUADRICICLO", carrocerias: [{ carroceria: "SIN CARROCERIA" }] },
    ],
    clientes: [],
    collection: "vehiculos",
    arrayLineas: [],
    marcas: [],
    marca: "",
    lineas: [],
    searchUsuario: "",
  }),
  props: {
    showModal: { type: Boolean, default: false },
    id: { type: String },
  },
  computed: {
    tituloModal(props) {
      return props.id ? "ACTUALIZAR" : "AGREGAR";
    },
    carrocerias() {
      const resultado = this.clases.find((x) => x.clase == this.objDatos.clase);
      return resultado ? resultado.carrocerias : resultado;
    },
    // lineas() {
    //   console.log("linea");
    //   this.objDatos.marca;
    //   const resultado = this.arrayLineas.filter(
    //     (x) => x.marca == this.objDatos.marca
    //   );
    //   console.log(resultado);
    //   return resultado ? resultado.lineas : resultado;
    // },
  },
  watch: {
    marca() {
      this.buscarLinea();
    },
    async searchUsuario(ahora) {
      if (!ahora || (ahora && ahora.includes("-"))) return;
      const Efectado = await db
        .collection("clientes")
        .where("identificacion", "==", ahora)
        .get();
      this.clientes = Efectado.docs.map((doc) => ({
        id: doc.id,
        nombresCompleto: `${doc.data().identificacion} - ${doc.data().nombres}
        ${doc.data().apellidos}`,
        ...doc.data(),
      }));
    },
  },
  async mounted() {
    const res = await db.collection("marcas").get();
    this.marcas = res.docs.map((doc) => ({
      id: doc.id,
      ...doc.data(),
    }));
  },
  async created() {
    this.getData();
    // const cliente = await db.collection("clientes").get();
    // this.clientes = cliente.docs.map((doc) => ({
    //   id: doc.id,
    //   nombresCompleto: `${doc.data().identificacion} | ${doc.data().nombres} ${
    //     doc.data().apellidos
    //   }`,
    //   ...doc.data(),
    // }));
  },
  methods: {
    async getData() {
      try {
        if (this.id) {
          const datos = await db.collection(this.collection).doc(this.id).get();
          this.objDatos = datos.data();
          this.marca = this.objDatos.marca;
        }
        this.loading = false;
      } catch (error) {
        this.handleError(error);
      }
    },
    async buscarLinea() {
      this.lineas = [];
      db.collection("lineas")
        .where("marca", "==", this.marca)
        .get()
        .then((resul) => {
          this.lineas = resul.docs.map((doc) => ({
            id: doc.id,
            ...doc.data(),
          }));
        });
    },
    async save() {
      try {
        const validar = await this.$refs.form_datos.validate();
        if (!validar) return false;
        this.loading = true;
        this.objDatos.marca = this.marca;
        Object.entries(this.objDatos).forEach((el) => {
          if (typeof el[1] === "string" && el[0] != "uidcliente") {
            this.objDatos[el[0]] = el[1].toUpperCase().trim();
          }
        });
        if (!this.id) {
          // Guardar
          this.objDatos.estado = "Activo";
          this.objDatos.creado = Date.now();
          await db.collection(this.collection).add(this.objDatos);
          this.$swal({ icon: "success", title: "Operacion Exitosa", text: "" });
          this.cerrarModal();
          this.$emit("actualizar");
        } else {
          // Actualizar
          this.objDatos.modificacion = Date.now();
          await db
            .collection(this.collection)
            .doc(this.id)
            .update(this.objDatos);
          this.$swal({ icon: "success", title: "Operacion Exitosa", text: "" });
          this.cerrarModal();
          this.$emit("actualizar");
        }
        this.loading = false;
      } catch (error) {
        console.log(error);
        this.handleError(error);
      }
    },
    cerrarModal() {
      this.$emit("update:showModal", !this.showModal);
      this.objDatos = {};
    },
    handleError({ message }) {
      this.$swal({ icon: "error", title: "Oops...", text: message });
      this.loading = false;
    },
  },
};
</script>
